import type { PartnerProgram } from "../customer-info/useCustomerProgram";

export interface VerificationUIConfigParams {
    isChat: boolean;
    programSelectionEnabled: boolean | undefined;
    programs: PartnerProgram[];
    useCustomerAgreementProgram: boolean;
    additionalVerificationFields: string[] | undefined;
    verificationType: "phoneNumber" | "billingAccountNumberAndPin";
}

export interface VerificationUIConfig {
    showProgramSelection: boolean;
    showAdditionalDetailsEmailInput: boolean;
    showAdditionalDetailsOrderIdInput: boolean;
    showAdditionalDetailsPhoneNumberInput: boolean;
}

/**
 * Computes the visibility flags for the verification UI based on partner config and context.
 */
export function computeVerificationUIConfig(params: VerificationUIConfigParams): VerificationUIConfig {
    const {
        isChat,
        programSelectionEnabled,
        programs,
        useCustomerAgreementProgram,
        additionalVerificationFields,
        verificationType,
    } = params;

    return {
        showProgramSelection:
            !isChat && !!programSelectionEnabled && programs.length > 1 && !useCustomerAgreementProgram,
        showAdditionalDetailsEmailInput: additionalVerificationFields?.includes("email") ?? false,
        showAdditionalDetailsOrderIdInput: additionalVerificationFields?.includes("orderId") ?? false,
        // Always expose the manual MDN input for BAN flows so the agent has a
        // safety valve when the IVR + partner lookup don't supply one.
        showAdditionalDetailsPhoneNumberInput: verificationType !== "phoneNumber",
    };
}
